import loadable from '@loadable/component';

/**
 * Code-split wrapper for AppDownloadPromoAfterLeadingBidHost — keeps it out of the initial bundle; it renders nothing at
 * first paint. Jest maps `*.loadable` modules to their eager originals (see jest.config.cjs).
 */
export const AppDownloadPromoAfterLeadingBidHost = loadable(
    /* #__LOADABLE__ */
    () => import('./AppDownloadPromoAfterLeadingBidHost'),
    {
        resolveComponent: (components) => components.AppDownloadPromoAfterLeadingBidHost,
        ssr: false,
    }
);
